<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="sendMailShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"
          ><i class="fas fa-paper-plane"></i
        ></span>
        <span class="p-l-20 p-r-10">Send Access Problem</span>
      </button>
    </div>
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="addShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
        <span class="p-l-20 p-r-10">Add User</span>
      </button>
    </div>
  </div>
  <dataTable
    :columnDefs="columnDefs"
    :name="'CustomerUsers'"
    ref="agGrid"
    :data="data"
    :addContextMenuItem="getContextMenuItems"
    @cellClicked="updateShow = $event.data"
  ></dataTable>
  <add
    v-if="addShow"
    :CustomerId="setModel.Id"
    @add="$refs.agGrid.addRow([$event])"
    @close="addShow = false"
  ></add>
  <update
    v-if="updateShow != null"
    :setModel="updateShow"
    :hotelId="setModel.Id"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="updateShow = null"
  ></update>
  <hotels
    v-if="hotelsOpen > 0"
    :customerId="setModel.Id"
    @close="hotelsOpen = 0"
    :userId="hotelsOpen"
  ></hotels>
  <sendAccessProblem
    :setModel="setModel"
    v-if="sendMailShow"
    @close="sendMailShow = false"
  ></sendAccessProblem>
</template>

<script>
import add from "./add";
import update from "./update";
import hotels from "./hotels/main";
import sendAccessProblem from "./../sendAccessProblem.vue";
import moment from "moment";
export default {
  name: "users",
  components: { add, update, hotels, sendAccessProblem },
  props: {
    setModel: Object,
  },
  data() {
    return {
      data: null,
      addShow: false,
      sendMailShow: false,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Statu",
          width: 110,
          filter: "agTextColumnFilter",
          field: "statu",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(e) {
            let clas = "success";
            if (e.value == "Passive") {
              clas = "danger";
            }
            if (e.value == "Control Required") {
              clas = "danger";
            }
            if (e.value == "Passive") {
              clas = "secondary";
            }
            return (
              '<span class="badge badge-' + clas + '">' + e.value + "</span>"
            );
          },
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Email",
          filter: "agTextColumnFilter",
          field: "Email",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Phone",
          filter: "agTextColumnFilter",
          field: "Phone",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Password",
          filter: "agTextColumnFilter",
          field: "Password",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Position",
          filter: "agTextColumnFilter",
          field: "Position",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "BirthDate",
          filter: "agTextColumnFilter",
          field: "BirthDate",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            return moment(new Date(params.value)).format("DD-MM-YYYY");
          },
        },
        // { headerName: "Burç ", filter: 'agTextColumnFilter', field: "BirthDate", flex: 1, minWidth:120, sortable:true, cellClick:true, enableRowGroup: true,
        //     valueFormatter:function(params){
        //       let birthDate=(new Date(params.value).getMonth()+1).toString()
        //       if(new Date(params.value).getDate().toString().length==1){
        //         birthDate=birthDate+"0";
        //       }
        //       birthDate+=new Date(params.value).getDate();
        //       birthDate=parseInt(birthDate);
        //       if(birthDate>=321 && birthDate<=420){
        //         return "Koç"
        //       }
        //       else if(birthDate>=421 && birthDate<=520){
        //         return "Boğa"
        //       }
        //       else if(birthDate>=521 && birthDate<=621){
        //         return "İkizler"
        //       }
        //       else if(birthDate>=622 && birthDate<=722){
        //         return "Yengeç"
        //       }
        //       else if(birthDate>=723 && birthDate<=823){
        //         return "Aslan"
        //       }
        //       else if(birthDate>=824 && birthDate<=923){
        //         return "Başak"
        //       }
        //       else if(birthDate>=924 && birthDate<=1022){
        //         return "Terazi"
        //       }
        //       else if(birthDate>=1024 && birthDate<=1122){
        //         return "Akrep"
        //       }
        //       else if(birthDate>=1123 && birthDate<=1221){
        //         return "Yay"
        //       }
        //        else if(birthDate<=1222 && birthDate<=120){
        //         return "Oğlak"
        //       }
        //       else if(birthDate>=121 && birthDate<=219){
        //         return "Kova"
        //       }
        //       else{
        //         return "Balık"
        //       }
        //     }
        // },
        {
          headerName: "DirectLoginKey",
          filter: "agTextColumnFilter",
          field: "DirectLoginKey",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "MassConfirm",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "MassConfirm",
          cellRenderer: this.$CheckCellRenderer,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        // {
        //   headerName: "IsCustomerAdmin",
        //   width: 80,
        //   filter: "agNumberColumnFilter",
        //   field: "IsCustomerAdmin",
        //   cellRenderer: this.$CheckCellRenderer,
        //   sortable: true,
        //   cellClick: true,
        //   enableRowGroup: true,
        // },
        {
          headerName: "Accountant",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Accountant",
          cellRenderer: this.$CheckCellRenderer,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
      ],
      hotelsOpen: 0,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`Customers/` + this.setModel.Id + `/Users`)
      .then((response) => {
        this.data = response.data.map((x) => {
          let statu = x.Active ? "Active" : "Passive";
          if (x.IsCustomerAdmin && x.Active) {
            statu += "-Admin";
          }
          return {
            ...x,
            Phone: "0" + x.Phone,
            statu: statu,
          };
        });
        this.detailShow = this.data[0];
      });
  },
  methods: {
    //sdfdsg
    directLogin(item) {
      console.log(item);
      window.open(
        "https://direct.kolayrez.com/#/direct-login/" + item.DirectLoginKey,
        "_blank"
      );
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer user named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Users/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer user has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    sendSms(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text: "Kullanıcı bilgileri sms ile gönderilsin mi?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`Users/sendInformation/` + item.Id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Sms gönderildi.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Direct Login",
          icon: "<i class='fas fa-sign-in-alt'></i>",
          action: () => {
            this.directLogin(params.node.data);
          },
        },
        {
          name: "Send SMS",
          icon: "<i class='fas fa-mobile-alt'></i>",
          action: () => {
            this.sendSms(params.node.data);
          },
        },
        {
          name: "Hotels",
          icon: "<i class='fas fa-building'></i>",
          action: () => {
            this.hotelsOpen = params.node.data.Id;
          },
        },
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
